import React, { useState } from 'react';
import './SessionList.css';
import ViewClassSession from '../ViewClassSession/ViewClassSession';

function SessionList() {
  const classes = Array.from({ length: 45 }, (_, index) => ({
    id: index + 1,
    name: `Class ${index + 1}`,
  }));

  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(classes.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentClasses = classes.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="classes-list-container">
      <div className="category-session-hor-list-grid">
        {currentClasses.map((classItem) => (
          <ViewClassSession key={classItem.id} name={classItem.name} />
        ))}
      </div>
      <div className="pagination">
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
}

export default SessionList;
